<template>
    <section class="seperartesection_class">
        <b-container>
            <b-row>
                <b-col>
                    <h6>Item Tracker</h6>
                </b-col>
                <b-col>
                    <i class="pi pi-times float-end" @click="goback"></i>
                </b-col>
            </b-row>
        </b-container>
    </section>
    <section class="form-white-bg">
        <b-container>
            <b-row>
                <b-col lg="3" md="4" sm="6" cols="12" class="field">
                    <label>Barcode</label>
                    <AutoCompleteCustom name="Barcode" label="Barcode" id="Barcode" v-model="datamodel.barcode"
                        :required-icon="true" :rules="{ required: true }" :items="barcodeitems"
                        @item-select="barcodechange" @input="barcodegenerate()" />
                </b-col>
            </b-row>
            <b-row v-if="itemdetails.length > 0">
                <b-col>
                    <p class="component-heading">Item Details</p>
                    <div class="item_tracker_card">
                        <!-- <img src="../../../../assets/Img/inventory/dummy_item.png" /> -->
                        <div>
                            <h6>{{ grnDetailItem?.ItemName || '-' }}</h6>
                            <div class="item_tracker_details">
                                <div class="seperatediv">
                                    <div>
                                        <div class="item_tracker_div">
                                            <span>GRN Id : </span>
                                            <span title="">{{ grnDetailItem?.DocNo || '-' }}</span>
                                        </div>
                                        <div class="item_tracker_div">
                                            <span>GRN Date : </span>
                                            <span title="">{{ grnDetailItem?.CreatedAt || '-' }}</span>
                                        </div>
                                        <div class="item_tracker_div">
                                            <span>Supplier : </span>
                                            <span title="">{{ grnDetailItem?.SupplierName || '-' }}</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="item_tracker_div">
                                            <span>Lot No : </span>
                                            <span title="">{{ grnDetailItem?.BarCode || '-' }}</span>
                                        </div>
                                        <div class="item_tracker_div">
                                            <span>Batch No : </span>
                                            <span title="">{{ grnDetailItem?.BatchNo || '-' }}</span>
                                        </div>
                                        <div class="item_tracker_div">
                                            <span>Expiry Date : </span>
                                            <span title="">{{ grnDetailItem?.ExpiryDate || '-' }}</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="item_tracker_div">
                                            <span>Brand Name : </span>
                                            <span title="">{{ grnDetailItem?.BrandName || '-' }}</span>
                                        </div>
                                        <div class="item_tracker_div">
                                            <span>Model Name No : </span>
                                            <span title="">{{ grnDetailItem?.ModelNumberName || '-' }}</span>
                                        </div>
                                        <div class="item_tracker_div">
                                            <span>Size : </span>
                                            <span title="">{{ grnDetailItem?.SizeName || '-' }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="seperatediv countdiv">
                                    <div>
                                        <h2><i class="pi pi-indian-rupee"></i>{{ grnDetailItem?.Rate || '-' }}.00</h2>
                                        <p>Unit Rate</p>
                                    </div>
                                    <div>
                                        <h2>{{ grnDetailItem?.ReceivedQty || '-'}}</h2>
                                        <p>Received Quantity</p>
                                    </div>
                                    <div>
                                        <h2 class="currentqty">{{ grnDetailItem?.CurrentQty || '-' }}</h2>
                                        <p>Current Quantity</p>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="itemdetails.length > 0">
                <b-col>
                    <div class="chip_class" v-if="activeFilter">
                        <div class="">
                            <div class="filter_chip" v-if="activeFilter">
                                <span>Filter Option: {{ activeFilter }}</span>
                                <span @click="removeFilter()"><i class="pi pi-times"></i>
                                </span>
                            </div>
                        </div>
                        <div class="">
                            <button class="btn resetallfilter me-2 rounded-pill float-end" @click="ResetFilter">
                                Clear all
                            </button>
                        </div>
                    </div>
                    <div v-if="windowWidth > 545">
                        <b-row>
                            <b-col :lg="visible ? '3' : '0'" v-if="visible">
                                <b-collapse id="collapse-1" class="mt-2" v-model="visible">
                                    <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
                                        :ClearDateFilter="SearchValue" v-if="FilterLoading">
                                        <template v-slot:filterslot>
                                            <div class="field">
                                                <MultiSelectDropdown label="Filter Options" v-model="selectedFilters"
                                                    :items="filterItems" @update:modelValue="onFilterChange" />
                                            </div>
                                        </template>
                                    </FilterForm>
                                </b-collapse>
                            </b-col>
                            <b-col :lg="visible ? '9' : '12'">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h6 class="my-3">Item Transaction Details</h6>
                                    <div>
                                        <i class="pi pi-filter itemtablefilter" :class="visible ? null : 'collapsed'"
                                            :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-1"
                                            @click="visible = !visible"></i>
                                    </div>
                                </div>
                                <DataTable :value="items" rowGroupMode="subheader" groupRowsBy="TransactionDetail"
                                    sortField="TransactionDetail" :sortOrder="1" class="p-datatable-sm">
                                    <template #groupheader="slotProps">
                                        <div class="flex items-center gap-2">
                                            <span>{{ slotProps.data.TransactionDetail }}</span>
                                        </div>
                                    </template>
                                    <!-- Dynamic Columns -->
                                    <Column v-for="col in headers" :key="col.field" :field="col.field"
                                        :header="col.header" :class="col.bodyclass || ''" :body="col.body">
                                        <!-- First slot type with style 1 -->
                                        <template #body="slotProps" v-if="col.field === 'ConsumedByUserName'">
                                            <slot :data="slotProps.data">
                                                {{ slotProps.data.ConsumedByPatientId != null ?
                                                    slotProps.data.ConsumedByPatientName : slotProps.data.ConsumedByUserName
                                                }}
                                            </slot>
                                        </template>
                                    </Column>

                                </DataTable>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>

    </section>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, computed, watch } from 'vue';
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import TextInput from "../../../../../components/FormComponents/TextInput.vue";
import NormalTableview from "../../../../../components/FormComponents/NormalTable.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import AutoCompleteCustom from "../../../../../components/FormComponents/AutoComplete.vue";
import FilterForm from "../../../../../components/FormComponents/FilterForm.vue";
import MultiSelectDropdown from "../../../../../components/FormComponents/MultiSelectDropdown.vue";
import ItemMasterService from "../../../../../modules/Inventory/Service/ItemMasService"

export default defineComponent({
    components: {
        TextField,
        TextInput,
        NormalTableview,
        AutoCompleteCustom,
        FilterForm,
        MultiSelectDropdown
    },
    setup() {
        const router = useRouter();
        const routes = useRoute();

        const datamodel = ref({
            barcode: ref(''),
        });
        const itemdetails = ref<any[]>([]);
        const allItems = ref<any[]>([]); // All items for the selected barcode
        const items = ref<any[]>([]); // Items displayed in the table (filtered or all)
        const barcodeitems = ref<any[]>([]);
        const loading = ref(false);
        const windowWidth = ref(window.innerWidth);
        const visible = ref(false);
        const FilterLoading = ref(true);


        // Single filter state
        const activeFilter: any = ref(''); // Empty string means no filter
        const selectedFilters: any = ref<string[]>([]);

        // Filter options
        const filterItems = ref([
            { name: 'Filter Only Used Items', value: 'used_items' },
        ]);

        const SearchValue = ref({
            inputValue: "",
            fromDate: "",
            toDate: "",
        });
        // Define the column header type
        type ColumnHeader = {
            header: string;
            field: string;
            filterTemplate: string;
            ShowMactchMode: boolean;
            bodyclass?: string;
            useSlot?: boolean;
            body?: (data: any) => string;
        };
        const grnDetailItem = computed(() => {
            return itemdetails.value.find(item => item.TransactionDetail === 'GRN Details');
        });
        const headers = ref<ColumnHeader[]>([
            { header: "InvoiceDate", field: "InvoiceDate", filterTemplate: "MultiSelect", ShowMactchMode: false },
            { header: "ItemName", field: "ItemName", filterTemplate: "MultiSelect", ShowMactchMode: false },
            { header: "BarCode", field: "BarCode", filterTemplate: "MultiSelect", ShowMactchMode: false, bodyclass: 'boldclass' },
            { header: "SupplierBarCode", field: "SupplierBarCode", filterTemplate: "MultiSelect", ShowMactchMode: false, bodyclass: 'red_td' },
            { header: "BatchNo", field: "BatchNo", filterTemplate: "MultiSelect", ShowMactchMode: false },
            { header: "ExpiryDate", field: "ExpiryDate", filterTemplate: "MultiSelect", ShowMactchMode: false },
            { header: "Qty", field: "Qty", filterTemplate: "MultiSelect", ShowMactchMode: false },
            { header: "FromStoreName", field: "FromStoreName", filterTemplate: "MultiSelect", ShowMactchMode: false },
            { header: "ToStoreName", field: "ToStoreName", filterTemplate: "MultiSelect", ShowMactchMode: false },
            { header: "SupplierName", field: "SupplierName", filterTemplate: "MultiSelect", ShowMactchMode: false },
            { header: "IssuedPatientName", field: "IssuedPatientName", filterTemplate: "MultiSelect", ShowMactchMode: false },
            {
                header: "ConsumedBy",
                field: "ConsumedByUserName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                useSlot: true,
            },
        ]);

        const goback = () => {
            router.back();
        };

        async function barcodegenerate() {
            try {
                const dataresponse = await ItemMasterService.GetSearchByLotNo(
                    datamodel.value.barcode,
                    routes.query.StoreId ?? 0
                );

                let GetItemByBarcode = dataresponse["result"]
                barcodeitems.value = GetItemByBarcode.map((item: any) => {
                    item.label = item.ItemName + " - " + item.BarCode;
                    item.value = item.BarCode;
                    return item;
                });
                console.log(barcodeitems.value);
            } catch (error) {
                console.log(error);
            }
        }

        async function barcodechange(event: any) {

            // Clear existing data
            itemdetails.value = [];
            items.value = [];
            allItems.value = [];
            activeFilter.value = '';
            selectedFilters.value = [];
            // Use the selected item's barcode
            let barcode = event.value.BarCode || event;

            try {
                const dataresponse = await ItemMasterService.GetItemTrackerDetailsByBarCode(
                    barcode
                );
                // Store the data
                const result = dataresponse["result"];
                allItems.value = [...result];
                items.value = [...result]; // Initially show all items
                itemdetails.value = [...result];
                console.log("Item data loaded:", items.value.length, "records");

            } catch (error) {
                console.log("Error fetching item data:", error);
            }
        }



        // Handle filter selection change
        function onFilterChange(values: string[], event?: Event) {
            // Update the selected filters immediately
            selectedFilters.value = values;

            if (!values || values.length === 0) {
                applyFilter('');
                return;
            }

            // Get the selected filter option
            const selectedValue = values[0]; // We only support one filter at a time
            const selectedOption = filterItems.value.find(option => option.value === selectedValue);
        }

        // Called when filter is applied from the filter form
        function Filter() {
            applyFilter(selectedFilters.value);
        }

        // Apply filter based on selection
        function applyFilter(filterName: string) {

            activeFilter.value = filterName;

            if (!filterName) {
                // No filter - show all items
                items.value = [...allItems.value];
                return;
            }

            // Apply "Used Items" filter
            if (filterName[0] === 'used_items') {
                items.value = allItems.value.filter((item: any) => {
                    return item.ConsumedByUserId !== 0 || item.ConsumedByPatientId !== null;
                });
            }
        }
        // Reset all filters
        function ResetFilter() {
            activeFilter.value = '';
            selectedFilters.value = [];
            items.value = [...allItems.value];
        }



        // Remove the filter chip
        function removeFilter() {
            activeFilter.value = '';
            selectedFilters.value = [];
            items.value = [...allItems.value];
        }


        // Update window width on resize
        onMounted(() => {
            window.addEventListener('resize', () => {
                windowWidth.value = window.innerWidth;
            });

            // Don't auto-load data on mount, wait for user to select an item
        });

        return {
            datamodel,
            items,
            headers,
            loading,
            goback,
            barcodegenerate,
            barcodechange,
            barcodeitems,
            itemdetails,
            windowWidth,
            visible,
            FilterLoading,
            filterItems,
            SearchValue,
            Filter,
            ResetFilter,
            removeFilter,
            activeFilter,
            selectedFilters,
            onFilterChange,
            allItems,
            grnDetailItem
        };
    }
});
</script>

<style lang="scss">
.filter_chip {
    background-color: #f0f7ff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-right: 10px;
    margin-bottom: 10px;
    display: inline-block;
    font-size: 12px;
}

.filter_chip span:nth-child(2) {
    cursor: pointer;
    margin-left: 5px;
}

.chip_class {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-block: 15px;
}

.itemtablefilter {
    cursor: pointer;
    font-size: 1.2rem;
    color: #4582ff;
    padding: 0.5rem;
    border-radius: 50%;
    transition: background-color 0.3s;
}

.itemtablefilter:hover {
    background-color: rgba(69, 130, 255, 0.1);
}

/* Styles for the custom slots */
.expiry-date-slot {
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block;
    background-color: #e8f5e9;
    color: #388e3c;
    font-weight: 500;
}

.quantity-slot {
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block;
    background-color: #e3f2fd;
    color: #1976d2;
    font-weight: 600;
    text-align: center;
    min-width: 40px;
}
</style>
<style lang="scss" scoped>
.seperartesection_class {
    background: #ffffff;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    padding: 15px;
    position: sticky;
    top: 0;
    z-index: 10;
}

.form-white-bg {
    background-color: #ffffff;
    padding: 15px;
    min-height: 100vh;
    box-sizing: border-box;
    padding-top: 50px;
}

.item_tracker_card {
    display: flex;
    background: #F9F9F9;
    border: 1px solid #e1e1e1;
    border-radius: 5px;
    font-size: 14px;

    img {
        height: 160px;
        width: 200px;
    }

    >div {
        padding: 15px;
        width: 100%;
    }

    .item_tracker_details {
        display: flex;
        align-items: center;
        justify-content: space-between;



        .seperatediv {
            display: flex;
            color: #999999;


            >div:not(:first-child) {
                border-left: 1px solid #e1e1e1;
            }

            >div {
                padding: 15px;
            }
        }

        .countdiv {
            h2 {
                color: #999999;
                font-weight: 400;
                font-size: 24px;
                text-align: center;
            }

            p {
                text-align: center;
            }

            .currentqty {
                color: #4D96FF;
            }

            >div {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
            }
        }

        .item_tracker_div {
            display: flex;
            gap: 10px;
            align-items: center;
            justify-content: space-between;
            margin-block: 9px;

            span:nth-child(1) {
                width: 100px;
            }

            span:nth-child(2) {
                width: 160px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style>